/**
 * Шаги уроков в порядке каталога (E4.6a). Модуль без импортов: его читают и каталог обучения,
 * и сквозные тесты Playwright, которым недоступны модули приложения с путями @/.
 */
export const LESSON_STEPS = {
	quick: ['overview', 'priority', 'resource', 'node', 'event'],
	map: ['grouping', 'clusters', 'filters', 'node'],
	investigation: ['event', 'resource', 'access', 'node', 'reports'],
	source: ['sensors', 'inventory', 'resource'],
	integrations: ['receivers', 'profile', 'deliveries', 'gaps', 'signals'],
	daily: ['overview', 'daily-priority', 'event', 'daily-assignment', 'daily-followup'],
	policy: ['policy-scope', 'policy-condition', 'policy-response', 'policy-event'],
	ai: ['ai-routes', 'ai-masking', 'ai-blocking', 'ai-events'],
	demo: ['overview', 'resource', 'grouping', 'node', 'access', 'event', 'receivers', 'reports'],
} as const;
